import { render, staticRenderFns } from "./lazy-img.vue?vue&type=template&id=548965de&"
import script from "./lazy-img.vue?vue&type=script&lang=js&"
export * from "./lazy-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports